import { type AdminModel } from '@/shared/api'
import { showDeleteConfirmationModal } from '@/shared/lib/antd-utils'
import { COMMON_COLUMN_WIDTH } from '@/shared/lib/styling'
import { DeleteOutlined, EditOutlined } from '@ant-design/icons'
import { Button, Space, type TableProps } from 'antd'
import { useUnit } from 'effector-react'

import { type AdminsSortState } from '../../lib/admins-query-model'
import { adminDeleted } from '../../model/admin.model'

interface useAdminsTableColumnsProps {
  onEdit: (adminId: string) => void
  sort: AdminsSortState
}
export const useAdminsTableColumns = ({
  onEdit: handleEdit,
  sort,
}: useAdminsTableColumnsProps): TableProps<AdminModel>['columns'] => {
  const deleteAdmin = useUnit(adminDeleted)
  const handleDelete = (id: string) => {
    showDeleteConfirmationModal({
      onConfirm: () => {
        deleteAdmin({ id })
      },
    })
  }

  return [
    {
      title: 'Наименование',
      dataIndex: 'login',
      key: 'login',
      sorter: true,
      ellipsis: true,
      sortOrder:
        sort.field === 'login'
          ? sort.order === 'asc'
            ? 'ascend'
            : sort.order === 'desc'
              ? 'descend'
              : null
          : null,
      render: (_, admin) => admin.login,
    },
    {
      title: '',
      width: COMMON_COLUMN_WIDTH.ACTIONS,
      key: 'actions',
      align: 'center',
      render: (_, admin) => (
        <Space size="middle">
          <Button
            onClick={() => handleEdit(admin.id)}
            icon={<EditOutlined />}
          />
          <Button
            onClick={() => handleDelete(admin.id)}
            icon={<DeleteOutlined style={{ color: 'red' }} />}
          />
        </Space>
      ),
    },
  ]
}
